<template>
    <my-form
    v-model="form"
    table
    label-width="180px"
    @cancle="cancleHandler"
    @submit="submitHandler">
        <el-form-item
        class="table-full-row"
        label="项目名称"
        >
            {{form.proname}}
        </el-form-item>

        <el-form-item
        class="table-full-row"
        label="招标公告是否发布"
        >
            <th-state :readonly="readonly"></th-state>
        </el-form-item>
        <template slot="btn" slot-scope="scope">
            <el-button
            :disabled="readonly"
            @click="scope.submitHandler"
            type="danger"
            icon="el-icon-circle-check">
                退回
            </el-button>
            <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

import ThState from '../components/th-state'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { ThState },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        form: {},
        shbj: '',
        fbbj: '',
    }),
    computed: {
        readonly() {
            return (
                this.shbj.indexOf('9') > -1 
                || this.fbbj.indexOf('1') > -1
            );
        },
    },
    methods: {
        submitHandler() {
            ShowConfirm('确认退回？','danger',()=> { 
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thproject.json`, this.data, (data, res) => {
                    ShowMsg(res.msg);
                    this.cancleHandler();
                });
            })
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thprojectinit.json`, this.data, data => {
            this.form = data.model;
            this.jspDataInit(data, ['shbj', 'fbbj']);
        });
    }
}
</script>

<style scoped lang="scss">

</style>